<template>
  <div id="footer-top">
    <b-row class="justify-content-lg-center">
      <b-col col lg="6">
        <div class="form">
          <h4>Envie-nos uma mensagem</h4>
          <p></p>
          <form action method="" role="form" class="contactForm">
            <div class="form-group">
              <input
                type="text"
                name="name"
                class="form-control"
                id="name"
                ref="name"
                placeholder="Seu Nome"
                data-rule="minlen:4"
                data-msg="Por favor digite seu nome"
                disabled
              >
              <div class="validation"></div>
            </div>
            <div class="form-group">
              <input
                type="email"
                class="form-control"
                name="email"
                id="email"
                ref="email"
                placeholder="Seu Email"
                data-rule="email"
                data-msg="Por favor digite seu e-mail"
                disabled
              >
              <div class="validation"></div>
            </div>
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                name="subject"
                id="subject"
                ref="subject"
                placeholder="Assunto"
                data-rule="minlen:4"
                data-msg="Assunto"
                disabled
              >
              <div class="validation"></div>
            </div>
            <div class="form-group">
              <textarea
                class="form-control"
                name="message"
                rows="5"
                data-rule="required"
                data-msg="Por favor escreva sua mensagem para nós"
                placeholder="Mensagem"
                disabled
              ></textarea>
              <div class="validation"></div>
            </div>

            <!--<div id="sendmessage">Sua mensagem foi enviada. Obrigado!</div>
            <div id="errormessage"></div>-->

            <!-- <div class="text-center"> -->
              <!-- <button class="g-recaptcha" data-callback="onSubmit" type="submit" title="Send Message">Enviar Mensagem</button> -->
              <!-- <button @click="recaptcha">Enviar Mensagem</button> -->
            <!-- </div> -->
          </form>
            <!-- <div class="text-center"> -->
              <!-- <button class="g-recaptcha" data-callback="onSubmit" type="submit" title="Send Message">Enviar Mensagem</button> -->
              <!-- <button @click="recaptcha">Enviar Mensagem</button> -->
              <!-- <vue-recaptcha ref="recaptcha" sitekey="6LfDDL8qAAAAAE9Gvhe6VaqpH5yrD3f1KscVBMOt"></vue-recaptcha> -->
            <!-- </div> -->
        </div>
      </b-col>
    </b-row>
    <br>
    <br>
    <br>
    <!-- <b-row>
      <b-col col lg="12" md="12">
        <div class="container">
          <div class="copyright">
            &copy; Copyright <strong>Maria Bailarina</strong>. Todos os Direitos Reservados
          </div>
          <div class="credits">
            Desenvolvido por UpApp
          </div>
        </div>
      </b-col>
    </b-row> -->
    <!-- <form id="demo-form" action="?" method="POST">
      <button class="g-recaptcha" data-sitekey="your_site_key" data-callback="onSubmit">Submit</button>
      <br/>
    </form> -->
  </div>
</template>

<script>
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "contato",
  component: {},
  data() {
    return {};
  },
  methods: {
    // async recaptcha() {
    //   // (optional) Wait until recaptcha has been loaded.
    //   await this.$recaptchaLoaded()

    //   // Execute reCAPTCHA with action "login".
    //   const token = await this.$recaptcha('site-mb  ')
    //   console.log(token);

    //   // Do stuff with the received token.
    // },
    async onSubmit(token) {

      // Dados do formulário
      // const formData = {
      //   name: this.$refs.name.value,
      //   email: this.$refs.email.value,
      //   subject: this.$refs.subject.value,
      //   message: this.$refs.message.value,
      //   "g-recaptcha-response": token, // Adicione o token gerado
      // };

      // try {
      //   // Enviar os dados ao back-end
      //   const response = await fetch("https://seu-backend.com/send-email", {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //     body: JSON.stringify(formData),
      //   });

      //   if (response.ok) {
      //     alert("Mensagem enviada com sucesso!");
      //   } else {
      //     alert("Erro ao enviar a mensagem. Por favor, tente novamente.");
      //   }
      // } catch (error) {
      //   console.error("Erro no envio:", error);
      //   alert("Erro ao enviar a mensagem. Por favor, tente novamente.");
      // }
    },
  }
};
</script>

<style scoped>
#footer {
  padding: 100px 0 100px 0;
  font-size: 14px;
  background: #fff;
  min-height: 800px;
}

#footer .footer-top {
  padding: 60px 0 30px 0;
  background: #f5f8fd;
}

#footer .footer-top .footer-info {
  margin-bottom: 30px;
}

#footer .footer-top .footer-info h3 {
  font-size: 34px;
  margin: 0 0 20px 0;
  padding: 2px 0 2px 0;
  line-height: 1;
  font-family: "Montserrat", sans-serif;
  color: #413e66;
  font-weight: 400;
  letter-spacing: 3px;
  text-transform: uppercase;
}

#footer .footer-top .footer-info p {
  font-size: 13px;
  line-height: 24px;
  margin-bottom: 0;
  font-family: "Montserrat", sans-serif;
  color: #535074;
}

#footer .footer-top .social-links a {
  font-size: 18px;
  display: inline-block;
  background: #1bb1dc;
  color: #fff;
  line-height: 1;
  padding: 8px 0;
  margin-right: 4px;
  border-radius: 50%;
  text-align: center;
  width: 36px;
  height: 36px;
  transition: 0.3s;
}

#footer .footer-top .social-links a:hover {
  background: #0a98c0;
  color: #fff;
}

#footer .footer-top h4 {
  font-size: 14px;
  font-weight: bold;
  color: #413e66;
  text-transform: uppercase;
  position: relative;
  padding-bottom: 10px;
}

#footer .footer-top .footer-links {
  margin-bottom: 30px;
}

#footer .footer-top .footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

#footer .footer-top .footer-links ul li {
  padding: 8px 0;
}

#footer .footer-top .footer-links ul li:first-child {
  padding-top: 0;
}

#footer .footer-top .footer-links ul a {
  color: #696592;
}

#footer .footer-top .footer-links ul a:hover {
  color: #1bb1dc;
}

#footer .footer-top .footer-contact {
  margin-bottom: 30px;
}

#footer .footer-top .footer-contact p {
  line-height: 26px;
}

#footer .footer-top .footer-newsletter {
  margin-bottom: 30px;
}

#footer .footer-top .footer-newsletter input[type="email"] {
  border: 0;
  padding: 6px 8px;
  width: 65%;
  border: 1px solid #d9dde6;
}

#footer .footer-top .footer-newsletter input[type="submit"] {
  background: #1bb1dc;
  border: 1px solid #1bb1dc;
  width: 35%;
  padding: 6px 0;
  text-align: center;
  color: #fff;
  transition: 0.3s;
  cursor: pointer;
}

#footer .footer-top .footer-newsletter input[type="submit"]:hover {
  background: #0a98c0;
}

#footer .footer-top .form .form-group {
  margin-bottom: 15px;
}

#footer .footer-top .form #sendmessage {
  color: #fff;
  background: #1bb1dc;
  display: none;
  text-align: center;
  padding: 15px;
  font-weight: 600;
  margin-bottom: 15px;
}

#footer .footer-top .form #errormessage {
  color: #fff;
  display: none;
  background: red;
  text-align: center;
  padding: 15px;
  font-weight: 600;
  margin-bottom: 15px;
}

#footer .footer-top .form #sendmessage.show,
#footer .footer-top .form #errormessage.show,
#footer .footer-top .form .show {
  display: block;
}

#footer .footer-top .form .validation {
  color: red;
  display: none;
  margin: 0 0 20px;
  font-weight: 400;
  font-size: 13px;
}

#footer .footer-top .form label {
  color: #413e66;
  font-weight: 500;
}

#footer .footer-top .form input,
#footer .footer-top .form textarea {
  border-radius: 0;
  box-shadow: none;
  border: 1px solid #dce1ec;
  font-size: 14px;
}

#footer .footer-top .form input::-webkit-input-placeholder,
#footer .footer-top .form textarea::-webkit-input-placeholder {
  color: #a2a0bd;
}

#footer .footer-top .form input::-moz-placeholder,
#footer .footer-top .form textarea::-moz-placeholder {
  color: #a2a0bd;
}

#footer .footer-top .form input:-ms-input-placeholder,
#footer .footer-top .form textarea:-ms-input-placeholder {
  color: #a2a0bd;
}

#footer .footer-top .form input::placeholder,
#footer .footer-top .form textarea::placeholder {
  color: #a2a0bd;
}

#footer .footer-top .form button[type="submit"] {
  background: #1bb1dc;
  border: 0;
  border-radius: 3px;
  padding: 8px 30px;
  color: #fff;
  transition: 0.3s;
}

#footer .footer-top .form button[type="submit"]:hover {
  background: #0a98c0;
  cursor: pointer;
}

#footer .copyright {
  text-align: center;
  padding-top: 30px;
  color: #535074;
  font-size: 15px;
}

#footer .credits {
  text-align: center;
  font-size: 14px;
  padding-top: 4px;
  color: #8582a8;
}

#footer .credits a {
  color: #1bb1dc;
}

#footer .credits a:hover {
  color: #0a98c0;
}
</style>



// WEBPACK FOOTER //
// src/views/contato.vue